import { render, staticRenderFns } from "./CoachingAuth.vue?vue&type=template&id=8897ba4e&scoped=true"
import script from "./CoachingAuth.vue?vue&type=script&lang=js"
export * from "./CoachingAuth.vue?vue&type=script&lang=js"
import style0 from "./CoachingAuth.vue?vue&type=style&index=0&id=8897ba4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8897ba4e",
  null
  
)

export default component.exports